
import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import{ axiosInstance } from "../useAxios/useAxios";

// const axiosInstance = axiosInstance;

export const getLabelList_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.labels + `?${query}`,
            method: "GET",
            // data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
} 


export const addLabel_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.labels,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
} 

export const updateDeleteLabel_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.labels,
            method: "PUT",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
} 